import { ensureDelay } from '../utils/async';

// make all request take at least 500ms for better visual responsiveness (no blinking loaders)
const ensureFetchDelay = <T>(promise: Promise<T> | (() => Promise<T>)) => {
  return ensureDelay(promise, 500);
};

async function fetchHelper<T = unknown>(url: string, options?: RequestInit) {
  const response = await ensureFetchDelay(window.fetch(url, options));

  if (!response.ok) {
    throw new Error(
      `Error when fetching ${url} response code: ${response.status}`
    );
  }

  return response.json() as Promise<T>;
}

export { fetchHelper, ensureFetchDelay };
